<template>
  <section class="issue-certificate">
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="true"
    />
    <form-header :title="$t('documentos.laudos.titulo')" />
    <div class="container-sarah">
      <form-steps :steps="steps" :current-step="currentStep" />
      <div class="form-template general-forms" v-if="!statePage">
        <p class="intro">
          {{ this.$t('documentos.laudos.info-solicitacao') }}
        </p>
        <form-select
          :data="optionData"
          :label="label"
          v-model="option.value"
          @change-data="checkSelectedOption($event)"
        />
        <b-field :label="$t('documentos.laudos.detalhe-solicitacao')">
          <b-input type="textarea" v-model="textInput" maxlength="2000" />
        </b-field>
        <b-field v-show="this.confirmarGovBr">
          <b-checkbox v-model="cienteGovBr">
            {{ this.$t('documentos.laudos.confirmar-gov-br') }}
          </b-checkbox>
        </b-field>
      </div>
      <state-response
        v-if="statePage"
        :state-title="stateTitle"
        :state-text="stateText"
        :button-text="buttonText"
        :status-ok="statusOk"
        @click-button="route"
      />
      <form-footer
        @go-to="postReport"
        :disabled="!disabledButton"
        :final-page="statePage"
        :ok-page="statusOk"
        :mult-comp="false"
        :last-comp="true"
      />
    </div>
  </section>
</template>

<script>
import FormHeader from '@/components/shared/header/FormHeader'
import FormFooter from '@/components/atestados/FormFooter'
import FormSteps from '@/components/shared/forms/FormSteps'
import FormSelect from '@/components/atestados/FormSelect'
import StateResponse from '@/components/atestados/StateResponse'
import { mapActions, mapGetters } from 'vuex'
import {
  TiposDocumentos,
  PasseLivreInterestadual
} from '../mixins/tipos-documentos'

export default {
  name: 'MedicalReport',
  components: {
    FormHeader,
    FormSteps,
    FormSelect,
    FormFooter,
    StateResponse
  },

  data() {
    return {
      stateTitle: '',
      stateText: '',
      isFullPage: true,
      statusOk: true,
      buttonText: this.$t('botoes.entendi'),
      statePage: false,
      valueSelected: '',
      idSelected: null,
      currentStep: 0,
      textInput: '',
      option: { value: this.$t('placeholders.dropdown') },
      label: this.$t('documentos.escolha-finalidade'),
      commonPlaceholder: this.$t('placeholders.common'),
      dropdown: this.$t('placeholders.dropdown'),
      steps: [{ name: 'Finalidade' }, { name: 'Informações Finais' }],
      confirmarGovBr: false,
      cienteGovBr: false
    }
  },
  created() {
    this.setRelatorioFinalidades()
  },
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      getRelatorioFinalidades: 'getRelatorioFinalidades',
      getResultadoSolicitacao: 'getResultadoSolicitacao'
    }),
    optionData: {
      get() {
        return Object.entries(this.getRelatorioFinalidades).map(
          ([key, value]) => {
            const dataCombo = {
              id: parseInt(key),
              value: value
            }
            return dataCombo
          }
        )
      }
    },
    disabledButton: {
      get() {
        return (
          this.textInput &&
          this.idSelected &&
          (!this.confirmarGovBr || (this.confirmarGovBr && this.cienteGovBr))
        )
      },
      set(newValue) {
        let checkButton = newValue
        return checkButton
      }
    }
  },
  methods: {
    ...mapActions(['setRelatorioFinalidades', 'solicitarRelatorio']),
    stepsChange() {
      this.currentStep++
    },
    checkSelectedOption(obj) {
      this.valueSelected = obj.value
      this.idSelected = obj.id

      this.confirmarGovBr = obj.id === PasseLivreInterestadual
      this.cienteGovBr = false
    },
    route() {
      this.$router.push('/documentos')
    },
    async postReport() {
      this.stepsChange()
      const payload = {
        Solicitacao: this.textInput,
        Finalidade: this.idSelected,
        Tipo: TiposDocumentos.Relatorio,
        Diagnosticos: []
      }
      await this.solicitarRelatorio(payload)
        .then(() => {
          this.statePage = true
          this.stateTitle = this.getResultadoSolicitacao.Titulo
          this.stateText = this.getResultadoSolicitacao.Mensagem
          this.buttonText = this.$t('botoes.confirmar')
        })
        .catch((err) => {
          this.statePage = true
          this.statusOk = false
          this.stateTitle = err.response.data.title
          this.stateText = err.response.data.detail
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/forms';
@import '~@/assets/stylesheets/warnings';
.issue-certificate {
  background-color: var(--gray-100);
  .container {
    height: 100%;
  }
  .general-forms {
    background-color: var(--bg-color-primary);
    margin-top: 1rem;
    max-height: 80vh;
    min-height: 31.8125rem;
    height: 100%;
    padding: 1.5rem;
    .intro {
      font-size: 1rem;
      margin-bottom: 1.7rem;
      line-height: 1.3;
      max-width: 80%;
    }
    .select-form {
      margin-bottom: 2.5rem;
    }
  }
  .textarea {
    max-width: 80%;
    min-width: 80%;
  }
  .warning {
    max-width: 80%;
  }
}
@media (max-width: $mobile-width-breakpoint) {
  .issue-certificate {
    .general-forms {
      max-height: 100%;
      padding-bottom: 3rem;
      .intro {
        max-width: 100%;
      }
      .select-form .dropdown {
        .dropdown-trigger {
          width: 100%;
        }
        .dropdown-menu {
          width: 100%;
        }
      }
    }
    .textarea {
      max-width: 100%;
    }
    .warning {
      max-width: 100%;
    }
  }
}
</style>
